const APPEARANCES = {
  DEFAULT: 'DEFAULT',
  COLOR_SWATCHES: 'COLOR_SWATCHES',
  SIZE_BUTTONS: 'SIZE_BUTTONS',
};

const MATCH_TYPES = {
  EQUALITY: 'EQUALITY',
  INCLUDES: 'INCLUDES',
  SIZE_AVAILABILITY: 'SIZE_AVAILABILITY',
};

const FILTER_IDENTIFIERS = {
  MATERIAL: 'material',
  HUE: 'hue',
  AVAILABILITY: 'isAvailable',
  BEST_FOR: 'bestFor',
  SIZE: 'size',
};

const FILTER_CONFIGURATIONS = {
  [FILTER_IDENTIFIERS.MATERIAL]: {
    filterIdentifier: FILTER_IDENTIFIERS.MATERIAL,
    attributeField: 'material',
    matchType: MATCH_TYPES.EQUALITY,
    appearance: APPEARANCES.DEFAULT,
  },
  [FILTER_IDENTIFIERS.HUE]: {
    filterIdentifier: FILTER_IDENTIFIERS.HUE,
    attributeField: 'hues',
    matchType: MATCH_TYPES.INCLUDES,
    appearance: APPEARANCES.COLOR_SWATCHES,
  },
  [FILTER_IDENTIFIERS.AVAILABILITY]: {
    filterIdentifier: FILTER_IDENTIFIERS.AVAILABILITY,
    attributeField: 'isAvailable',
    matchType: MATCH_TYPES.EQUALITY,
    appearance: APPEARANCES.DEFAULT,
  },
  [FILTER_IDENTIFIERS.BEST_FOR]: {
    filterIdentifier: FILTER_IDENTIFIERS.BEST_FOR,
    attributeField: 'bestFor',
    matchType: MATCH_TYPES.INCLUDES,
    appearance: APPEARANCES.DEFAULT,
  },
  [FILTER_IDENTIFIERS.SIZE]: {
    filterIdentifier: FILTER_IDENTIFIERS.SIZE,
    attributeField: 'sizeHandles',
    matchType: MATCH_TYPES.SIZE_AVAILABILITY,
    appearance: APPEARANCES.SIZE_BUTTONS,
  },
};

const COLLECTION_PAGE_FILTER_IDENTIFIERS = [
  FILTER_IDENTIFIERS.SIZE,
  FILTER_IDENTIFIERS.BEST_FOR,
  FILTER_IDENTIFIERS.MATERIAL,
  FILTER_IDENTIFIERS.HUE,
];

// Prefix the constants to choose sort order
const SIZE_FILTER_GROUPINGS = {
  SHOE: 'shoe',
  UNISEX_SHOE: 'unisexShoe',
  APPAREL: 'apparel',
  UNISEX_APPAREL: 'unisexApparel',
};

export {
  FILTER_CONFIGURATIONS,
  COLLECTION_PAGE_FILTER_IDENTIFIERS,
  APPEARANCES,
  MATCH_TYPES,
  FILTER_IDENTIFIERS,
  SIZE_FILTER_GROUPINGS,
};
